// src/Api/ExamsAttendedAPI.js
import { get } from "./api"; // your axios wrapper

export const fetchTestAttempts = async (page = 1, limit = 10) => {
  try {
    const endpoint = `/test/attempts?page=${page}&limit=${limit}`;
    const response = await get(endpoint);

    console.log("API response:", response);
    console.log("API response data:", response.data);

    // Handle different response structures
    if (response && response.data) {
      // Check if response.data is directly an array (as shown in your console.log)
      if (Array.isArray(response.data)) {
        return {
          data: response.data,
          total: response.total || response.data.length,
          page: page,
          limit: limit,
        };
      }

      // Check if response.data has a nested data property that's an array
      if (response.data.data && Array.isArray(response.data.data)) {
        return {
          data: response.data.data,
          total: response.data.total || response.data.data.length,
          page: page,
          limit: limit,
        };
      }

      // If response.data exists but doesn't match expected structure
      return {
        data: [],
        total: 0,
        page: page,
        limit: limit,
      };
    }

    // If no response.data, return empty
    return {
      data: [],
      total: 0,
      page: page,
      limit: limit,
    };
  } catch (error) {
    console.error("Error fetching test attempts:", error);
    return {
      data: [],
      total: 0,
      page: page,
      limit: limit,
      error: error.message,
    };
  }
};
